import { HttpStatusCode } from "axios";

import { LocalKeyType, getLocalValue, setLocalValue } from "./localStorage";
import { reissueToken } from "./request";

import { ScopeType, getLongTermToken } from "../services/authServices";

export const setLongTermToken = async (key: LocalKeyType) => {
  const jwtTokenString = getLocalValue("jwtToken");
  // setError((prev) => prev + " 1." + JSON.stringify(jwtTokenString));
  if (!jwtTokenString) return;
  const jwtToken = JSON.parse(jwtTokenString);

  const response = await reissueToken(jwtToken);
  // setError((prev) => prev + " 2." + JSON.stringify(response));
  if (response.status !== HttpStatusCode.Ok) return;

  const res = await getLongTermToken(
    {
      accessToken: `Bearer ${response.data.accessToken}`,
    },
    { scope: key as ScopeType }
  );
  // setError((prev) => prev + " 3." + JSON.stringify(res));
  if (res.status !== HttpStatusCode.Ok) return;
  setLocalValue(key, res.data.longTermToken);
};
